import React from 'react';
import ActionConfigurator from '../components/ActionConfigurator';
import { useNavigate } from 'react-router-dom';

const SettingsPage = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--rhea-bg-primary)' }}
    >
      {/* Fixed Header with Logo and Settings */}
      <div className="fixed top-0 left-0 right-0 px-4 py-4 border-b w-full bg-[var(--rhea-bg-primary)] z-10" style={{ borderColor: 'var(--rhea-card-border)' }}>
        <div className="flex items-center gap-4 cursor-pointer" onClick={() => navigate('/easter-egg')}>
          <img src="/assets/rhea/logo.png" alt="Rhea" className="h-16" />
        </div>
        <h1 
          className="text-3xl font-semibold absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{ color: 'var(--rhea-text-primary)' }}
        >
          Settings
        </h1>
      </div>
      
      {/* Scrollable Content */}
      <div className="flex-1 mt-[88px] overflow-auto">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <ActionConfigurator />
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
